import getTopics from 'services/apiHelpers/getTopics';
import { findBlocksIn } from 'selectors/block';
import getStore from 'services/getStore';

const store = getStore();

const getActiveBlocks = () => {
  const { blocks, rootBlockId } = store.getState();
  return findBlocksIn(blocks, blocks[rootBlockId], () => true);

  // first thought was this might be the ' highest level '
  // where we can getActiveBlocks from
  // const { blocks } = store.getState();
  // const topics = getTopics();

  // return topics.reduce(
  //   (acc, curr) => [...acc, ...findBlocksIn(blocks, curr, () => true)],
  //   []
  // );
};

export default getActiveBlocks;
